import { useEffect, useState } from "react";
import { api, API } from "@/lib/apiClient";
import { FileText, Download, FileType, File as FileIcon } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import ReferralShare from "@/components/ReferralShare";

export default function Library() {
  const [files, setFiles] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  useEffect(() => { api.get("/library").then((r) => setFiles(r.data)); }, []);

  return (
    <main className="bg-onyx min-h-screen pt-16" data-testid="library-page">
      <div className="border-b border-white/10 grain bg-surface">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4 flex items-center gap-2"><FileText size={16} /> Downloadable Library</p>
          <h1 className="font-serif text-4xl md:text-6xl text-bone mb-4">The Archive</h1>
          <p className="text-bone/55 max-w-2xl text-lg">PDFs, scriptures, study guides and documents preserved for the seekers of knowledge. Download freely.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        {files.length === 0 ? (
          <div className="text-center py-24 border border-dashed border-white/10" data-testid="library-empty">
            <FileIcon className="text-bone/20 mx-auto mb-4" size={48} strokeWidth={1} />
            <p className="text-bone/50">The archive is being prepared. A credentialed administrator can upload files from the Admin Panel.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="library-grid">
            {files.map((f) => (
              <div key={f.id} className="bg-surface border border-white/10 p-6 hover:border-gold/40 transition-colors flex flex-col" data-testid="library-card">
                <div className="flex items-start justify-between mb-4">
                  <FileType className="text-gold" size={30} strokeWidth={1.5} />
                  <span className="text-xs font-mono text-bone/40 border border-white/10 px-2 py-1">{f.file_type} · {f.size_kb}KB</span>
                </div>
                <h3 className="font-serif text-xl text-bone mb-2">{f.title}</h3>
                <p className="text-bone/50 text-sm leading-relaxed mb-2">{f.description}</p>
                <p className="text-xs text-gold/70 mb-5">{f.category}</p>
                <a href={`${API}/library/${f.id}/download`} data-testid="library-download-button"
                  onClick={() => { trackEvent("guide_download", { title: f.title }); setTimeout(() => setShareOpen(true), 800); }}
                  className="mt-auto flex items-center justify-center gap-2 bg-gold text-black py-2.5 font-medium hover:bg-gold2 transition-colors">
                  <Download size={16} /> Download
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
      <ReferralShare open={shareOpen} onClose={() => setShareOpen(false)} heading="Thank you — now pass it on" />
    </main>
  );
}
